import styled, { css } from 'styled-components';

export const Colours = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  list-style: none;
  margin: 8px 0 0 4px;
  padding: 0;
  justify-content: flex-start;
`;

// prettier-ignore
export const ColourItem = styled.button`
  background-color: #${(props) => (props.colour ? props.colour : '')};
  ${({ imageUrl }) => imageUrl && css`
    background-image: url(${imageUrl});
    background-size: cover;
  `}
  display: block;
  width: 27px;
  height: 27px;
  border: none;
  border-radius: 100px;
  margin-right: 16px;
  cursor:pointer;
  box-shadow: 0 0 0 2px rgb(243, 243, 243), 0 0 0 3px transparent;

  &:hover {
    @-moz-document url-prefix() {
      box-shadow: 0 0 0 2px #fff, 0 0 0 3px #d9d9d9;
    }
  }

  &.default {
    background: linear-gradient(
      -45deg,
      #333,
      #333 50%,
      #333 49%,
      white 51%,
      white 51%
    );
    border-radius: 50%;
    box-shadow: 0 0 0 2px #fff, 0 0 0 3px #d9d9d9;
  }
  ${(props) => props.selected === props.name
    ? `
      box-shadow: 0 0 0 2px #fff, 0 0 0 4px #333333;
      cursor:auto;

      @-moz-document url-prefix() {
        box-shadow: 0 0 0 2px #fff, 0 0 0 3px #333333;
      }

      &:hover {
        @-moz-document url-prefix() {
          box-shadow: 0 0 0 2px #fff, 0 0 0 3px #333333;
        }
      }

      &.default{
        box-shadow: 0 0 0 2px #fff, 0 0 0 4px #333333;
      }
      `
    : null}
`;

export const ColourList = styled.div`
  background-color: #${(props) => (props.colour ? props.colour : '')};
  display: block;
  border-radius: 100px;
  margin: 0 5px 5px 0;
  width: 10px;
  height: 10px;
  border: 1px solid #979797;
`;
